var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.075707 479.186212l102.632541 102.399814 226.070861-226.070861a46.54537 46.54537 0 1 1 65.815154 65.815153L507.181623 669.76623a47.569368 47.569368 0 0 1-9.309074 13.96361 48.10464 48.10464 0 0 1-35.351208 13.963611 45.917007 45.917007 0 0 1-36.026116-13.032703 45.311918 45.311918 0 0 1-7.54035-11.35707l-126.254316-125.835408a48.314094 48.314094 0 0 1 68.375148-68.282058zM511.999069 1023.999767A511.999069 511.999069 0 0 1 0 512.000698a46.54537 46.54537 0 0 1 93.09074 0 419.536692 419.536692 0 1 0 155.926989-325.817589H325.817589a46.54537 46.54537 0 0 1 0 93.09074H139.63611a46.54537 46.54537 0 0 1-46.54537-46.54537h-9.890891c3.141812-4.840718 6.58617-9.471983 9.890891-14.196338V46.546999a46.54537 46.54537 0 0 1 93.09074 0v70.842053A511.999069 511.999069 0 1 1 511.999069 1023.999767z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.4f94252ef0a209f6aae3c39dbef523db.svg";
export { ForwardRef as ReactComponent };